import React from "react";
import logo from "../../assets/Logo.svg";

const MeetingDetails = ({ selectedEventType, userDetails }) => {
  if (!selectedEventType) return null;

  return (
    <div className="p-5 md:border-r border-b border-gray-200 w-full md:w-[40%]">
      <div className="flex flex-col gap-3 mb-4">
        <div className="w-6 h-6 bg-primary/10 rounded-full flex items-center justify-center overflow-hidden">
          {userDetails?.avatar ? (
            <img
              src={userDetails.avatar}
              alt={userDetails.name || "User"}
              className="w-full h-full object-cover"
            />
          ) : (
            <img src={logo} alt="logo" className="w-full h-full object-cover" />
          )}
        </div>
        <div>
          <h3 className="text-sm font-medium text-gray-600">
            {userDetails?.name || "RegTechFlow"}
          </h3>
        </div>
      </div>

      <div className="mb-4">
        <h4 className="text-xl font-bold text-[#101010] mb-2">
          {selectedEventType.title || "Support Meeting"}
        </h4>
        <p className="text-sm text-[#374151] leading-tight">
          {selectedEventType.description || "RegTechFlow Support Session"}
        </p>
      </div>

      <div className="space-y-1">
        <div className="flex items-center gap-2 text-sm text-[#374151]">
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span>{selectedEventType.length || 30} mins</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-[#374151]">
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
            />
          </svg>
          {/* <span>Google</span> */}
          <span className="capitalize">
            {selectedEventType?.locations
              ?.map(
                (location) =>
                  (location.type && location.type.split(":")[1]) || ""
              )
              .join(", ")}
          </span>
        </div>
        <div className="flex items-center gap-2 text-sm text-[#374151]">
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9v-9m0-9v9"
            />
          </svg>
          <span>{Intl.DateTimeFormat().resolvedOptions().timeZone}</span>
        </div>
      </div>
    </div>
  );
};

export default MeetingDetails;
